import React from "react";
import { Typography, Button, Flex } from "antd";
import heroImg from "../../assets/landing-page/hero.png";

const { Title, Paragraph } = Typography;

function HeroSection({ openTrialSignup, openSignup, isLoginOpen, isSignupOpen }) {
  const handleStartNow = () => {
    if (typeof openSignup === "function") {
      openSignup(false);
    }
  };

  const handleGetFreeTrial = () => {
    if (typeof openTrialSignup === "function") {
      openTrialSignup("");
    } else if (typeof openSignup === "function") {
      openSignup(true);
    }
  };

  return (
    <section className="hero-section-wrapper" id="home">
      <div className="hero-outer-frame">
        {/* MAIN ROUNDED PRIMARY CARD */}
        <div className="hero-primary-card">
          <div className="hero-content-container">
            <Flex vertical gap={24} className="hero-focused-content">
              {/* Main H1 Headline from Spec */}
              <Title level={1} className="hero-title-main">
                Close Deals Faster with Automated Call Intelligence &amp; Pipeline Telemetry
              </Title>

              {/* Sub-headline Paragraph from Spec */}
              <Paragraph className="hero-subtitle-desc">The all-in-one sales CRM engineered for modern closing teams. Automatically capture customer calls, eliminate 7-day stagnant deals, access complete 360° company profiles, and generate GST invoices on web and Android.</Paragraph>

              {/* TWO CLEAN CTA BUTTONS: START NOW & GET FREE TRIAL */}
              {!isLoginOpen && !isSignupOpen && (
                <Flex wrap="wrap" gap={14} className="hero-cta-button-group">
                  <Button size="large" className="hero-btn-primary" onClick={handleStartNow}>
                    Start Now
                  </Button>
                  <Button size="large" className="hero-btn-secondary" onClick={handleGetFreeTrial}>
                    Get Free Trial
                  </Button>
                </Flex>
              )}
            </Flex>
          </div>

          {/* BOTTOM-RIGHT HERO GRAPHIC IMAGE */}
          <div className="hero-bottom-right-wrapper">
            <img src={heroImg} alt="DealVoice Telemetry & Sales Platform" className="hero-bottom-right-img" />
          </div>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
